import $ from 'jquery';
import modaal from 'modaal';
import * as CONST from '../../common/utils/constants';

class Modal {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		// Not your agent modal - ADA Compliance: Do not allow Tab or Shift + Tab to move focus outside of a modal dialog
		$('.js-menu-modal').modaal({
			content_source: '#removeAgent',
			type: 'inline',
			after_open: () => {
				$('.modaal-content-container').removeAttr('role');
				$('.modaal-content.modaal-focus').attr('aria-modal', 'true');
				$('.modaal-close').focus();
				$('.modaal-container').on('keydown', (e) => {
					if ($(e.target).hasClass('js-find-different-agent') && e.key === 'Tab' && !e.shiftKey) {
						e.preventDefault();
						$('.modaal-close').focus();
					}
					if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && !e.shiftKey) {
						e.preventDefault();
						$('.js-keep-agent').focus();
					}
					if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && e.shiftKey) {
						e.preventDefault();
						$('.js-find-different-agent').focus();
					}
					if ($(e.target).hasClass(' js-keep-agent') && e.key === 'Tab' && e.shiftKey) {
						e.preventDefault();
						$('.modaal-close').focus();
					}
				});
			}
		});

		// Change location modal - ADA Compliance: Do not allow Tab or Shift + Tab to move focus outside of a modal dialog
		$('.js-inline-modal').modaal({
			content_source: '#change-location',
			type: 'inline',
			after_open: () => {
				$('.modaal-content-container').removeAttr('role');
				$('.modaal-close').focus();
				$('.modaal-close span').attr('aria-hidden', 'true');
				$('.modaal-content.modaal-focus').attr('aria-modal', 'true');
				$('.modaal-content.modaal-focus').removeAttr('tabindex');
				$('.modaal-container').on('keydown', (e) => {
					if ($(e.target).hasClass('js-change-location') && e.key === 'Tab' && !e.shiftKey) {
						e.preventDefault();
						$('.modaal-close').focus();
					}
					if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && !e.shiftKey) {
						e.preventDefault();
						$('#ZipCodeLocation').focus();
					}
					if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && e.shiftKey) {
						e.preventDefault();
						$('.js-change-location').focus();
					}
					if ($(e.target).is('#ZipCodeLocation') && e.key === 'Tab' && e.shiftKey) {
						e.preventDefault();
						$('.modaal-close').focus();
					}
				});
			}
		});

		$('.js-keep-agent').on('click', (event) => {
			$('.js-menu-modal').modaal('close');
		});

		$('.js-remove-agent-info').on('click', (event) => {
			document.cookie = 'agentId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
			// if agent page redirect to home otherwise reload
			if (window.location.href.indexOf('/find-an-agent/') > 0) {
				window.location.href = '/';
			} else {
				window.location.reload();
			}
		});

		// Not your agent modal
		$('.js-inline-modal').modaal({
			after_open: (event) => {
				$('.modaal-content-container').removeAttr('role');
				$('.modaal-close').focus();
				if ($('.modaal-wrapper.modaal-inline').is(':visible') && $('.modaal-wrapper.modaal-inline').find('#ZipCodeLocation').length > 0) {
					$('.modaal-content-container').addClass('changeLocationCustom');
				}
			},
			after_close: () => {
				$('video').each((x, y) => { y.pause(); });
			}
		});

		$('.js-inline-video-modal').modaal(
			{
				after_open: () => {
					$('.modaal-content-container').removeAttr('role');
					$('.modaal-close').focus();
					if ($('.modaal-wrapper.modaal-inline').is(':visible') && $('.modaal-wrapper.modaal-inline').find('#ZipCodeLocation').length > 0) {
						$('.modaal-content-container').addClass('changeLocationCustom');
					}
				},	
				after_close: () => {
					$('video').each((x, y) => { y.pause(); });
				}		
			}
		);

		$('.js-video').modaal({
			type: 'video',
			width: 920,
			after_open: () => {
				let title = $('.video-trigger');
				if (title.length > 0) {
					title = $(title).data('title');
				} else {
					title = '';
				}

				$('.modaal-content-container').removeAttr('role');
				$('.modaal-close').focus();
				jQuery('#modaal-close').detach().appendTo('.modaal-video-container');
				jQuery('#modaal-close').addClass('modaal-close--no-icon');
				jQuery('.modaal-video-frame').attr('title', title);
				jQuery('.modaal-video-wrap.modaal-focus').attr('aria-modal', true);
				jQuery('.modaal-video-wrap.modaal-focus').attr('aria-label', 'Employees Testimonials Video');
				jQuery('.modaal-video-wrap.modaal-focus').removeAttr('tabindex');
				jQuery('.modaal-close').append('<span class="modaal-close-icon modaal-close-icon--auto" aria-hidden="true"></span>');
				jQuery('span.modaal-close-icon').prev().addClass('sr-only');
				jQuery('.modaal-video-wrap.modaal-focus').addClass('first-focusable-element');
				jQuery('button.enter-fullscreen-icon').addClass('last-focusable-element');
				$('.modaal-outer-wrapper').click((event) => {
					if (event.target.className.indexOf('modaal-video-wrap') >= 0) {
						$('#modaal-close').click();
					}
				});
			}
		});

		$('.image-modal').modaal({
			type: 'image',
			width: 930,
			after_open: () => {
				$('.modaal-content-container').removeAttr('role');
				$('.modaal-close').focus();
			}
		});
    }
}

export default Modal;

$(() => {
	const modal = new Modal();
	modal.init();
});